import { HttpClient } from '@angular/common/http';
import { Injectable } from '@angular/core';
import { Observable } from 'rxjs';
import { ConfigurationService } from '../services/configuration.service';

@Injectable({
    providedIn: 'root',
})
export class UserHttpService {
    constructor(private configurations: ConfigurationService, private http: HttpClient) {}

    getAllUsers(): Observable<any> {
        return this.http.get<any>(`${this.configurations.baseUrl}/api/account/getAllUsers`);
    }

    getUserById(id: any): Observable<any> {
        return this.http.get<any>(`${this.configurations.baseUrl}/api/account/geUserById`, { params: { id: id } });
    }

    newUser(user: any): Observable<any> {
        return this.http.post<any>(`${this.configurations.baseUrl}/api/account/newUser`, user);
    }

    editUser(user: any): Observable<any> {
        return this.http.put<any>(`${this.configurations.baseUrl}/api/account/editUser`, user, { params: { id: user.id } });
    }

    resetUserPassword(email: any, password: any): Observable<any> {
        return this.http.put<any>(
            `${this.configurations.baseUrl}/api/account/resetUserPassword`,
            {},
            {
                params: { email: email, password: password },
            }
        );
    }

    deleteUserById(id: any): Observable<any> {
        return this.http.delete<any>(`${this.configurations.baseUrl}/api/account/deleteUserById`, { params: { id: id } });
    }

    toggleEnableUser(id: any, value: any): Observable<any> {
        return this.http.put<any>(
            `${this.configurations.baseUrl}/api/account/toggleEnableUser`,
            {},
            {
                params: { id: id, value: value },
            }
        );
    }
}
